"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査結果のヘッダ項目
 */
const HEADER_HEIGHT = 90;
const HeaderContainer = (0, _styles.styled)(_Grid.default)({
  height: HEADER_HEIGHT
});
const TopRow = (0, _styles.styled)(_Grid.default)({
  height: '54%'
});
const BottomRow = (0, _styles.styled)(_Grid.default)({
  height: '46%'
});
const CellBottomLeft = (0, _styles.styled)(_Grid.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    borderBottom: 'solid 1px',
    borderBottomColor: theme.palette.border.white,
    borderLeft: 'solid 1px',
    borderLeftColor: theme.palette.border.white,
    display: 'flex',
    alignItems: 'flex-end'
  };
});
const CellLeft = (0, _styles.styled)(_Grid.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    borderLeft: 'solid 1px',
    borderLeftColor: theme.palette.border.white
  };
});
const HeaderCells = props => {
  const {
    intl
  } = props;
  return /*#__PURE__*/_react.default.createElement(HeaderContainer, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(TopRow, {
    container: true,
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(CellBottomLeft, {
    size: {
      xs: 3
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_TITLE
  })), /*#__PURE__*/_react.default.createElement(CellBottomLeft, {
    size: {
      xs: 5
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_SHITEKI_KAIZEN
  })), /*#__PURE__*/_react.default.createElement(CellBottomLeft, {
    size: {
      xs: 4
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_CHIEF_HYOKA
  }))), /*#__PURE__*/_react.default.createElement(BottomRow, {
    container: true,
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    direction: "row",
    alignItems: "stretch",
    size: {
      xs: 3
    }
  }, /*#__PURE__*/_react.default.createElement(CellLeft, {
    size: {
      xs: 6,
      sm: 6,
      md: 6
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_MAKING_STATUS
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 6,
      sm: 6,
      md: 6
    }
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    direction: "row",
    alignItems: "stretch",
    size: {
      xs: 5
    }
  }, /*#__PURE__*/_react.default.createElement(CellLeft, {
    size: {
      xs: 5,
      sm: 5,
      md: 5
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_IMPROVEMENT_PLAN_STATUS
  })), /*#__PURE__*/_react.default.createElement(CellLeft, {
    size: {
      xs: 4,
      sm: 4,
      md: 4
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_PROGRESS_STATUS
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 3,
      sm: 3,
      md: 3
    }
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    direction: "row",
    alignItems: "stretch",
    size: {
      xs: 4
    }
  }, /*#__PURE__*/_react.default.createElement(CellLeft, {
    size: {
      xs: 5,
      sm: 5,
      md: 5
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_EVALUATION_STATUS
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 7,
      sm: 7,
      md: 7
    }
  }))));
};
var _default = exports.default = (0, _reactIntl.injectIntl)(HeaderCells);